<template>
  <app-dropdown
    placeholder="Filter by Invoice"
    track-by="id"
    label="label"
    :options="invoiceSelection"
    :loading="loading"
    :disabled="dropdownDisabled"
    v-bind="attrs"
    @on-selected="onInvoiceSelected"
    @on-removed="onInvoiceRemoved"
  />
</template>

<script>
import AppDropdown from "../AppComponents/AppDropdown.vue";
import ApiMixin from "../../mixins/ApiMixin";
import CampaignServices from "../../services/campaigns";

export default {
  mixins: [ApiMixin],
  components: {
    AppDropdown
  },
  computed: {
    attrs() {
      const { placeholder, options, ...rest } = this.$attrs;
      return rest;
    },
    // Function to determine if the dropdown should be disabled
    dropdownDisabled() {
      if (this.loading) return true;
      if (this.attrs.disabled) return this.attrs.disabled;

      return false;
    },
    invoiceSelection() {
      return [
        {
          id: "no",
          label: "No"
        },
        {
          id: "yes",
          label: "Yes"
        }
      ];
    }
  },
  methods: {
    onInvoiceSelected(props) {
      this.$emit("on-invoice-selected", props);
    },
    onInvoiceRemoved(props) {
      this.$emit("on-invoice-removed", props);
    }
  },
  inheritAttrs: false
};
</script>
